module.exports = __webpack_public_path__ + "img/LS-M-18.3136a0b5.svg";